<umkt-card-wrapper
  [title]="'pages.productLink.title' | i18n"
  [icon]="{ name: 'engrenagem', type: 'mondrian-icons' }"
  [showCheck]="showCheck"
  [loading]="isLoading"
  [loadingText]="'shared.messages.processing' | i18n"
  [initiallyOpen]="isLastStep ? true : true"
>
  <div class="product-link-card-container">
    <!-- Estado de visualização -->
    <div *ngIf="!isEditing" class="pi-container">
      <div class="warning-box" *ngIf="showAutoLinkWarning">
        <span class="mdn-Icon-circulo-exclamacao mdn-Icon--md warning-icon"></span>
        <span class="warning-text">
          {{ 'pages.productLink.viewMode.autoLinkWarning' | i18n }}
        </span>
      </div>

      <div *ngIf="hasProducts">
        <div class="pi-product-item" *ngFor="let product of products; let i = index; let last = last">
          <div class="pi-config-header">
            <div class="pi-config-icon">
              <umkt-icon [icon]="product.icon" size="sm"></umkt-icon>
            </div>
            <div class="pi-config-title">
              <h3>{{ product.productName }}</h3>
              <p>{{ product.planName }}</p>
            </div>
            <div class="pi-actions" *ngIf="i === 0">
              <button type="button" class="pi-edit-btn" (click)="editPayment()">{{ 'pages.productLink.editButton' | i18n }}</button>
            </div>
          </div>
          <div class="pi-linked-lines">
            <p class="pi-linked-lines-label">{{ 'pages.productLink.viewMode.linesLabel' | i18n }}</p>
            <div class="pi-linked-lines-list" *ngIf="product.selectedMsisdns.length > 0">
              <p class="pi-linked-line" *ngFor="let line of product.selectedMsisdns">{{ line.label }}</p>
            </div>
            <p class="pi-no-lines" *ngIf="product.selectedMsisdns.length === 0">{{ 'pages.productLink.viewMode.noLines' | i18n }}</p>
          </div>
          <div class="pi-divider" *ngIf="!last"></div>
        </div>
      </div>
      <div class="pi-empty" *ngIf="!hasProducts">
        <p>{{ 'pages.productLink.empty' | i18n }}</p>
      </div>
    </div>

    <!-- Estado de edição -->
    <div *ngIf="isEditing" class="pi-edit-mode">
      <!-- Informational text -->
      <div class="intro-section">
        <p class="intro-text">
          {{ 'pages.productLink.editMode.intro' | i18n }}
        </p>

        <!-- Warning message -->
        <div class="warning-box">
          <span class="mdn-Icon-circulo-exclamacao mdn-Icon--md warning-icon"></span>
          <span class="warning-text">
            {{ 'pages.productLink.editMode.warning' | i18n }}
          </span>
        </div>
      </div>

      <div class="pi-container" *ngIf="hasProducts">
        <div class="pi-product-item" *ngFor="let product of products; let i = index; let last = last">
          <div class="pi-config-header">
            <div class="pi-config-icon">
              <umkt-icon [icon]="product.icon" size="sm"></umkt-icon>
            </div>
            <div class="pi-config-title">
              <h3>{{ product.productName }}</h3>
              <p>{{ product.planName }}</p>
            </div>
          </div>

          <p class="pi-instruction">{{ 'pages.productLink.editMode.instruction' | i18n }}</p>

          <umkt-multi-select-input
            [placeholder]="'pages.productLink.editMode.selectPlaceholder' | i18n"
            [items]="product.availableMsisdns"
            [listTitle]="'pages.productLink.editMode.listTitle' | i18n"
            [placeholderFilter]="'shared.placeholders.search' | i18n"
            [warningMessageTemplate]="'pages.productLink.editMode.warningSelect' | i18n"
            [selectedItems]="product.selectedMsisdns"
            [requiredCount]="product.subscriptionCount"
            (selectionChange)="onLineSelectionChange(i, $event)"
            [class.ng-invalid]="product.selectedMsisdns.length !== product.subscriptionCount"
            [class.ng-valid]="product.selectedMsisdns.length === product.subscriptionCount"
          ></umkt-multi-select-input>

          <p class="pi-status" [class.incomplete]="product.selectedMsisdns.length !== product.subscriptionCount">
            <ng-container *ngIf="product.selectedMsisdns.length !== product.subscriptionCount">
               {{ 'pages.productLink.editMode.statusIncomplete' | i18n }}
            </ng-container>
            <ng-container *ngIf="product.selectedMsisdns.length === product.subscriptionCount">
               {{ 'pages.productLink.editMode.statusComplete' | i18n: { 
                    count: product.selectedMsisdns.length,
                    lines: (product.selectedMsisdns.length === 1 ? 'pages.productLink.plurals.lineSingular' : 'pages.productLink.plurals.linePlural') | i18n,
                    s: (product.selectedMsisdns.length === 1 ? 'pages.productLink.plurals.suffixSingular' : 'pages.productLink.plurals.suffixPlural') | i18n
               } }}
            </ng-container>
          </p>

          <div class="pi-divider" *ngIf="!last"></div>
        </div>
      </div>

      <!-- Empty state -->
      <div class="pi-empty" *ngIf="!hasProducts">
        <p>{{ 'pages.productLink.empty' | i18n }}</p>
      </div>

      <!-- Actions buttons -->
      <div class="product-link-card-actions">
        <button 
          class="btn-outline" 
          *ngIf="isLastStep && isEditing; else backButton"
          (click)="cancelEdit()">
          {{ 'shared.buttons.cancel' | i18n }}
        </button>
        <ng-template #backButton>
          <button class="btn-outline" (click)="onPreviousStep()" [disabled]="!canGoToPreviousStep">
            {{ 'shared.buttons.back' | i18n }}
          </button>
        </ng-template>
        <button 
          class="btn-primary" 
          (click)="saveAndContinue()" 
          [disabled]="isLastStep ? !isFormValid() : (!canGoToNextStep || !isFormValid())">
          {{ (isLastStep ? 'shared.buttons.save' : 'shared.buttons.continue') | i18n }}
        </button>
      </div>
    </div>
  </div>
</umkt-card-wrapper>